export const ANNUAL_INCOME_TOOLTIP_TEXT = 'Total amount of income earned annually before taxes.';
export const TOTAL_NET_WORTH_TOOLTIP_TEXT =
  'Net worth is what you own minus what you owe excluding your primary residence.';
export const LIQUID_NET_WORTH_TOOLTIP_TEXT =
  'Liquid net worth is the part of your assets that can readily be turned into cash. This includes investments such as stocks and mutual funds but not real estate and cars.';
